export default __webpack_public_path__ + "static/social-enterprise-small-867296945e2a53dc2e83321fba9f823e.svg";